export interface ChartPreferences {
  defaultSymbol: string;
  defaultTimeframe: '1m' | '5m' | '15m' | '30m' | '1h' | '4h' | '1d' | '1w';
  defaultRange: '1D' | '3D' | '5D' | '1M' | '3M' | '6M' | 'YTD' | '1Y' | '2Y' | '5Y';
}

export interface UserPreferences {
  // Core preferences
  theme: 'dark' | 'light';
  lastRoute: string;
  chart: ChartPreferences;

  // Onboarding fields
  hasCompletedOnboarding?: boolean;
  accountBalance?: number;
  tradingStyle?: 'day' | 'swing' | 'position';
  tradingExperience?: 'beginner' | 'intermediate' | 'advanced';
  tradingGoals?: string[];
  primaryFocus?: 'performance' | 'learning' | 'both';
  onboardingCompletedAt?: number;
  onboardingVersion?: number;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  theme: 'dark',
  lastRoute: '/app',
  chart: {
    defaultSymbol: 'AAPL',
    defaultTimeframe: '1d',
    defaultRange: '6M',
  },
};

// Default values for new users during onboarding
export const DEFAULT_ONBOARDING_PREFERENCES = {
  hasCompletedOnboarding: false,
  accountBalance: 10000,
  tradingStyle: 'swing' as const,
  tradingExperience: 'beginner' as const,
  tradingGoals: [] as string[],
  onboardingVersion: 1,
};
